export default {
  currentImage: state => state.currentImage,
  productInspiration: state => state.productInspiration,
  productCross: state => state.productCross,
  productComplementary: state => state.productComplementary,
  variants: state => state.variants,
  product: state => state.product,
  productRR: state => state.productRR
};